module.exports = __webpack_public_path__ + "img/08.10ef9bef.jpg";